
import './App.css';
import AddToAny from './AddToAny/AddToAny';

function App() {
  return (
    <div className="App">
      <h1>AddToAny</h1>
      <AddToAny />
    </div>
  );
}

export default App;
